const INITIAL_STATE = {
  applyTypeList: [],
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_APPLY_TYPE_LIST":
      return {
        ...state,
        applyTypeList: action.data
      };
    default:
      return state;
  }
};

export default reducer;